// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { z } from "zod";

import { CheckInQuestionId, CheckInSectionId } from "./usNeCheckInToolSpec";

// TODO(OBT-47841): this is a dummy schema, replace with a more useful one
// derived from CheckInQuestionId
export const usNeCheckInSchema = z.object({}).passthrough();

export type UsNeCheckInAnswers = z.output<typeof usNeCheckInSchema>;

export type CheckInQuestionInfo = {
  questionId: CheckInQuestionId;
  sectionId: CheckInSectionId;
};

export type CheckInStatus =
  | {
      kind: "NOT_STARTED";
      firstQuestion: CheckInQuestionInfo;
    }
  | {
      kind: "QUESTION";
      question: CheckInQuestionInfo;
      isFirstQuestionOfSection: boolean;
    }
  | {
      kind: "COMPLETED";
    };
